var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ELEMENT } from './ELEMENT';
var DIV = /** @class */ (function (_super) {
    __extends(DIV, _super);
    function DIV(props, childNodes) {
        var _this = 
        // 'div' в нижнем регистре чтобы не попасть под обфускатор
        _super.call(this, 'div', props || {}, childNodes) || this;
        if (typeof props === 'object' && props.html) {
            _this.html(props.html);
        }
        return _this;
    }
    Object.defineProperty(DIV.prototype, "scrollHeight", {
        get: function () {
            return this.el.scrollHeight;
        },
        enumerable: false,
        configurable: true
    });
    DIV.prototype.scrollToBottom = function () {
        this.el.scrollTo(0, this.scrollHeight);
    };
    return DIV;
}(ELEMENT));
export { DIV };
